

@if (isOnboarding) {
    <page-with-splash>
        <ng-container [ngTemplateOutlet]="profileContent" />
    </page-with-splash>
} @else {
    <mce-page-with-navigation>
        <div>
            <ng-container [ngTemplateOutlet]="profileContent" />
        </div>
    </mce-page-with-navigation>
}

<ng-template #profileContent>

    <div class="w-full">

        <h2>{{ isOnboarding ? 'Complete Your Profile' : 'Your Profile' }}</h2>

        <form>

            <div class="mce-form-section">

                <div class="mce-form-section-title">[{{profileEditForm().value().email}}]</div>

                <div>

                    @if (isOnboarding) {
                        <p>Please ensure your profile is complete to continue</p>
                    }

                    <div>
                        <mce-image-upload [title]="'Select Profile Image'"
                                          [initialImageUrl]="profileEditForm().value().photoUrl?.value ?? null"
                                          [maxSize]="512000"
                                          [formField]="profileEditForm.imageData64">

                        </mce-image-upload>
                    </div>



                </div>

                <div class="mce-form-field-group">

                    <div>
                        <mat-form-field class="">
                            <mat-label>display name</mat-label>
                            <input matInput placeholder="enter your display name"
                                   [formField]="profileEditForm.displayName" />

                            @for (error of profileEditForm.displayName().errors(); track error.kind ) {
                            <mat-error>
                                {{ error.message }}
                            </mat-error>
                            }
                        </mat-form-field>
                    </div>

                    <div>
                        <mat-form-field class="">
                            <mat-label>first name</mat-label>
                            <input matInput placeholder="enter your first name"
                                   [formField]="profileEditForm.firstName"
                                   test-id="firstName" />

                            @for (error of profileEditForm.firstName().errors(); track error.kind ) {
                            <mat-error>
                                {{ error.message }}
                            </mat-error>
                            }
                        </mat-form-field>
                    </div>

                    <div>
                        <mat-form-field class="">
                            <mat-label>last name</mat-label>
                            <input matInput placeholder="enter your last name"
                                   [formField]="profileEditForm.lastName"
                                   test-id="lastName" />

                            @for (error of profileEditForm.lastName().errors(); track error.kind ) {
                            <mat-error>
                                {{ error.message }}
                            </mat-error>
                            }

                        </mat-form-field>
                    </div>

                </div>
            </div>


        </form>


        <mce-save-cancel [config]="saveCancelConfig()"
                         (action)="onSaveCancelAction($event)">
            @if (isOnboarding) {
                <button matButton="elevated" type="button"
                        [disabled]="!profileEditForm().valid() || profileEditForm().submitting()"
                        (click)="onSave()">
                    <mat-icon>save</mat-icon>Save and Continue
                </button>
            }
        </mce-save-cancel>

        @for (error of profileEditForm().errors(); track error.kind) {
            <p class="text-error mt-4" role="alert">{{ error.message }}</p>
        }

        <div>
            <mat-toolbar>
                <mat-toolbar-row class="bg-on-tertiary-container h-auto flex flex-wrap gap-2 py-2 sm:gap-4">


                    <div>
                        <button matButton type="button" [disabled]="profileEditForm().submitting()" (click)="onSignOut()">
                            <mat-icon>logout</mat-icon>Log Out
                        </button>
                    </div>

                    @if (!isOnboarding) {
                    <div>
                        <button matButton type="button" [disabled]="profileEditForm().submitting()" (click)="onDeleteAccount()">
                            <mat-icon>delete</mat-icon>Delete Account
                        </button>
                    </div>

                    <div>
                        <button matButton type="button" [disabled]="profileEditForm().submitting()" (click)="onChangeEmail()">
                            <mat-icon>alternate_email</mat-icon>Change Email
                        </button>
                    </div>
                    }


                </mat-toolbar-row>
            </mat-toolbar>

            <div class="mt-4">
                <app-debug-panel [form]="profileEditForm()"></app-debug-panel>
            </div>
        </div>



        @if (profileEditForm().submitting()) {
        <div class="spinner">
            <mat-spinner test-id="spinner"></mat-spinner>
        </div>
        }

    </div>



</ng-template>


